export default [
    {
        path: process.env.IS_LOCAL === 'true' ? '' : '' + '/protocols',
        name: 'Protocols',
        component: () => import("@/pages/Experts/ExpertProtocols.vue"),
        meta:{
            roles: ['EXPERT_KCP_ROLE', 'ADMIN_ROLE'],
        }
    },
]